import React, { forwardRef } from 'react';

import { cssMap, cx } from '@atlaskit/css';

import { Table as PTable, type TableProps } from '../../ui/primitives/table';

const styles = cssMap({
	table: {
		display: 'grid',
		overflow: 'visible',
	},
});

/**
 * __Table__
 *
 * A data table is used to display dynamic data.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 */
export const Table: React.ForwardRefExoticComponent<Omit<TableProps, "ref"> & React.RefAttributes<HTMLTableElement>> = forwardRef<HTMLTableElement, TableProps>(
	({ children, testId, xcss, ...props }, ref) => {
		return (
			<PTable testId={testId} xcss={cx(styles.table, xcss)} ref={ref} {...props}>
				{children}
			</PTable>
		);
	},
);
